export default __webpack_public_path__ + "static/media/XHighlight Logo Transparent Background.4b944d6c.png";